import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-compound-features',
  standalone: true,
  imports: [CommonModule],
  template: `
    <div
      class="surface-card p-5 sm:p-6 border border-border shadow-sm antialiased relative overflow-hidden"
    >
      <div
        class="absolute right-0 top-0 w-32 h-full bg-gradient-to-l from-primary/5 to-transparent pointer-events-none"
      ></div>

      <div class="flex items-center gap-3 pb-4 mb-5 border-b border-dashed border-border-subtle">
        <div
          class="w-10 h-10 rounded-2xl bg-surface-elevated flex items-center justify-center text-primary shrink-0 shadow-sm border border-border"
        >
          <i class="fa-solid fa-city text-sm"></i>
        </div>
        <div>
          <h4
            class="text-[10px] font-black uppercase tracking-widest text-primary font-mono"
          >
            مرافق مميزة
          </h4>
          <h2 class="text-sm sm:text-base font-black text-text-primary tracking-tight mt-0.5">
            مميزات <span class="text-text-primary font-black">{{ compoundName || 'الكمبوند' }}</span>
          </h2>
        </div>
      </div>

      @if (compoundFeatures.length) {
        <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3">
          @for (feature of compoundFeatures; track feature) {
            <div
              class="flex items-center gap-3 bg-bg-secondary hover:bg-surface-hover border border-border hover:border-primary/40 rounded-2xl p-3.5 transition-all duration-300 group hover:shadow-lg"
            >
              <div
                class="w-6 h-6 rounded-lg bg-success/10 border border-success/20 flex items-center justify-center text-success shrink-0 transition-transform duration-300 group-hover:scale-110"
              >
                <i class="fa-solid fa-square-check text-[11px]"></i>
              </div>

              <span
                class="text-xs font-bold text-text-secondary group-hover:text-text-primary transition-colors duration-300 truncate"
                [title]="feature"
              >
                {{ feature }}
              </span>
            </div>
          }
        </div>
      } @else {
        <div
          class="py-8 flex flex-col items-center justify-center border border-dashed border-border bg-bg-secondary/40 rounded-2xl text-center font-mono px-4"
        >
          <div
            class="w-12 h-12 rounded-2xl bg-surface-elevated flex items-center justify-center text-text-muted mb-4 border border-border-subtle shadow-sm"
          >
            <i class="fa-solid fa-tree-city text-lg"></i>
          </div>
          <h4 class="text-xs font-black text-text-secondary uppercase tracking-wider mb-2">
            لم يتم تعيين الخدمات
          </h4>
          <p
            class="text-[11px] font-medium text-text-muted max-w-xs leading-relaxed normal-case font-sans"
          >
            خدمات الكمبوند ومواصفات البنية التحتية غير متوفرة بعد.
          </p>
        </div>
      }
    </div>
  `,
})
export class CompoundFeaturesComponent {
  @Input() compoundFeatures: string[] = [];
  @Input() compoundName: string = '';
}
